import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FirestoreService } from '../firestore-service.service';
import { Post, PostField, Template, TemplateField } from '../container';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ConfirmingDialogComponent } from '../confirming-dialog/confirming-dialog.component';
import { getAuth } from 'firebase/auth';
import { AddworkpackagedialogComponent } from '../addworkpackagedialog/addworkpackagedialog.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PostsearchpopupComponent } from '../postsearchpopup/postsearchpopup.component';

interface Row {
  contentKey: string;
  order: number;
}

@Component({
    selector: 'app-linkedcontent',
    templateUrl: './linkedcontent.component.html',
    styleUrls: ['./linkedcontent.component.scss'],
    imports: [
      CommonModule, 
      FormsModule, 
      PostsearchpopupComponent,
      ConfirmingDialogComponent
    ],
    standalone: true
})
export class LinkedcontentComponent {
 // @ViewChildren('inputRef') inputRefs: QueryList<ElementRef>;
  @Input() organizationKey = ""
  @Input() projectKey = ""
  @Input() userId = ""
  @Input() contentKey = ""
  @Input() tableJson = ""
  @Input() isReadOnly = false
  @Input() fieldKey = ""
  @Input() embeddingModel = ""
  @Output() listenTable = new EventEmitter<{"table": string, "fieldKey": string}>();
  emptyTableJson = '{"rows": []}'
  table: Row[] = []
  showSearchwModal = false
  userDisplayName = ""
  templates: Template[] = []
  menuItems: {key: string, name: string, color: string}[] = []
  fieldKeyWithLinks = -1
  projectName = ""

  content: {"key": string, "title": string, "name": string, "nameHTML": string, "dateOfCreation": string, "ners": {"type": string, "content": string,}[], "coverImageURL": string, "isDeleted": boolean, "projectKey": string, "projectName": string, "color": string}[] = []

  showPopupMenu = false
  isLoadingLabelVisible = false

  constructor(private router: Router, public dialog: MatDialog, private firestore: FirestoreService) {
  }

  ngAfterViewInit() {
    getAuth().onAuthStateChanged(user => { 
      if (user) {
        this.userDisplayName = user.displayName||""
        setTimeout(() => { 
          this.converTableJson()
          this.reorderTable()
          this.getContent()
        }, 0);
      }
    })
  }

  getContent() {
    for (let i = 0; i < this.table.length; i++) {
      this.firestore.getContent(this.organizationKey, this.table[i].contentKey).then(result => {
        if (result.isDeleted == false) {
          this.content.push(result)
        }
      })
    }
  }

  hasValueInContentKey(v: string): boolean {
    return this.table.some(row => row.contentKey === v);
  }

  converTableJson() {

      if (this.tableJson == undefined || this.tableJson == '') {
        this.tableJson = this.emptyTableJson
      }
      try {
        const parsedData = JSON.parse(this.tableJson) as { rows: Row[] }; // Type assertion
        this.table = parsedData.rows.map(row => ({  // Create new Row objects
          contentKey: row.contentKey,
          order: row.order
          })); 
          this.table.sort((rowA, rowB) => rowA.order - rowB.order); 
      } catch (error) {
        console.error('Error fetching data:', error);
        this.tableJson = this.emptyTableJson
      }

  }

  reorderTable() {
    for (let i = 0; i < this.table.length; i++) {
      this.table[i].order = i
    }
  }

  updateTableJson() {
    this.tableJson = JSON.stringify(this.table);
    this.listenTable.emit({"table": this.tableJson, "fieldKey": this.fieldKey})
  }

  addContent() {
    this.showSearchwModal = true
  }

  deleteContentLink(index: number) {
    this.content.splice(index, 1)
    this.table.splice(index, 1)
    this.updateTableJson()
  }

  receivedContent(value: {"key": string, "name": string}[]) {
    this.showSearchwModal = false
    if (value.length > 0) {
      value.forEach(v => {
        const hasVale = this.hasValueInContentKey(v.key)
        if (this.contentKey != v.key && hasVale == false) {
          this.table.push({"contentKey": v.key, "order": this.table.length})
          this.firestore.getContent(this.organizationKey, v.key).then(result => {
            if (result.isDeleted == false) {
              this.content.push(result)
              this.updateTableJson()
              this.firestore.showSnackBar("New content has been linked to this one.")
            }
          })
        } else if (this.contentKey == v.key) {
          this.firestore.showSnackBar("You cannot link content to itself")
        } else if (hasVale == true) {
          this.firestore.showSnackBar("This content is already added.")
        } 
      })

    }
  }

  launchPostDialog(postKey: string, postName: string, postHTMLName: string, isNewPost: boolean) {
    this.firestore.getPost(this.organizationKey, postKey).then((result) => {
      const embedding = result.get("embedding")
      let post: Post = {"authorKey": result.get("authorKey"), "authorName": result.get("authorName"), "categoryKey": "", "color": result.get("color"), "commentCount": result.get("commentCount"), "contentRowsCount": result.get("contentRowsCount"), "contentType": result.get("contentType"), "coverImageURL": result.get("coverImageURL"), "dateOfCreation": result.get("dateOfCreation"), "dateOfUpdate": result.get("dateOfUpdate"), "fields": result.get("fields"), "formattedDate": result.get("formattedDate"), "imageURLs": result.get("imageURLs"), "isDeleted": result.get("isDeleted"), "isDownloadAvailable": result.get("isDownloadAvailable"), "isNewPost": false,  "key": postKey, "lastCommentDate": result.get("lastCommentDate"), "loggedUserDisplayName": result.get("loggedUserDisplayName"), "loggedUserKey": result.get("loggedUserKey"), "name": result.get("name"), "nameHTML": result.get("nameHTML"), "organizationKey": this.organizationKey, "projectKey": result.get("projectKey"), "projectName": result.get("projectName"), "tags": result.get("tags"), "templateKey": result.get("templateKey"), "title": result.get("title"), "viewCount": result.get("viewCount"), "embedding": embedding, "isRead": false, "isTop": false, "isFavourite": false, "progressPercent": result.get("progressPercent"), "manHours": result.get("manHours"), "startDate": result.get("startDate"), "endDate": result.get("endDate"), "isSelected": result.get("isSelected") || false, templateName: result.get("templateName"), "isCompleted": false, "parentName": "", "areKidsColored": false, "description": "", "assignedUsers": [], "status": "", "sequence": 0, "parentKey": "", "isExpanded": false, "areKidsTagged": false, "milestoneKey": "", "isChecked": false, "isParent": false, "fileType": result.get("type") || ""}
      this.firestore.getWorkpackageFields(this.organizationKey, postKey).then(f => {
        let fields = f
        if (fields == undefined && post.contentType != "canvas") { // in case of canvas in knowledge base do not generate template fields
          let templateIndex = this.getTemplateIndex(post.templateKey)
          fields = this.generateFields(this.templates[templateIndex].fields)
        }
        if (post.contentType != "canvas") { // for posts open popup
          const dialogRef = this.dialog.open(AddworkpackagedialogComponent, {
            disableClose: true,
            panelClass: "dialog-container",
            width: '95vw',
            maxWidth: '100vw',
            maxHeight: '100vh',
            height: 'calc(100vh - 50px)',
            //enterAnimationDuration,
            //exitAnimationDuration,
            data: {
              post: post,
              menuItems: this.menuItems,
              key: post.key,
              name: postName,
              HTMLname: postHTMLName,
              isNewPost: isNewPost,
              organizationKey: this.organizationKey,
              projectKey: post.projectKey,
              projectName: post.projectName,
              color: post.color,
              content: post.nameHTML,
              title: post.title,
              viewCount: post.viewCount,
              userId: this.userId,
              userDisplayName: this.userDisplayName,
              loggedUserKey: this.userId,
              templateKey: post.templateKey,
              fields: fields,
              templates: this.templates,
              fieldKeyWithLinks: this.fieldKeyWithLinks,
              channelKey: post.key,
              tags: post.tags,
              coverImageURL: post.coverImageURL,
              contentType: post.contentType,
              embedding: post.embedding,
              isRead: post.isRead,
              isTop: post.isTop,
              isFavourite: post.isFavourite,
              isReadOnly: this.isReadOnly,
              type: "post",
              embeddingModel: this.embeddingModel,
              startDate: post.startDate,
              endDate: post.endDate,
              manHours: post.manHours,
              progressPercent: post.progressPercent
            },
          });
          dialogRef.afterClosed().subscribe((result: any) => { // when post or task dialog is closed, store data in the database
            post.key = ""
            if ((result != undefined)&&(result != "")) {
              if (result.isDownloadAvailable == undefined) {
                result.isDownloadAvailable = false
              }
              let color = result.color
              let areKidsColored = result.areKidsColored
              let name = result.name
              let nameHTML = result.nameHTML
              let parentName = ""//result.parentName
              let contentType = result.contentType
              if (result.isDeleted == true) {
                const dialogConfirmingRef = this.dialog.open(ConfirmingDialogComponent, {
                  data: {"content": "Are you sure to remove this task?", "onlyCloseButton": false}
                });
                dialogConfirmingRef.afterClosed().subscribe((r) => {
                  if (r == true) {
                    this.firestore.removePost(result.key, this.organizationKey, this.projectKey)
                    this.firestore.showSnackBar("The task has been deleted.");
                  }
                })
              } else {
                this.firestore.updateWorkpackageName(this.organizationKey, this.projectKey, this.projectName, postKey, this.userId, this.userDisplayName, name, parentName, contentType, nameHTML)
                this.firestore.updateWorkpackageFields(this.organizationKey, postKey, result.fields)
                this.firestore.updateWorkpackageColor(this.organizationKey, postKey, color, areKidsColored)
              }
            }
          });
        } else { // for canvases just redirect to canvas
          let canvasKey = post.key
       //   this.router.navigate(["canvas/"+this.organizationKey+"/"+this.projectKey+"/"+canvasKey])
        }
      })
    })
  }

  generateFields(templateFields: TemplateField[]) {
    let fields: PostField[] = [];
    for (let i = 0; i < templateFields.length; i++) {
      let placeholder = ""
      try {
        const parsedContent = JSON.parse(templateFields[i].contentJson)
        placeholder = parsedContent.placeholder
      } catch (error) {
        placeholder = templateFields[i].name
      }
      fields.push({key: templateFields[i].key, content: "", "placeholder": placeholder, type: templateFields[i].type, noteType: templateFields[i].noteType, sequence: i, "links": [], "uid": this.firestore.generateUID(), "date": "", isExpanded: false, label: templateFields[i].name}) // add actual field
    }
    return fields
  }

  getTemplateIndex(templateKey: string) {
    for (let i = 0; i < this.templates.length; i++) {
      if (this.templates[i].key == templateKey) {
        return i
      }
    }
    return -1
  }
}
